module.exports = __webpack_public_path__ + "img/brainfit_7.27cd11ce.jpg";